<template>
  <q-dialog :visible.sync="isVisible" title="拒绝" width="500px" :innerScroll="false" @close="onCancel">
    <div class="reject-content">
      <el-form ref="rejectForm" :model="formData" :rules="rules" size="mini" label-width="110px">
        <el-form-item label="拒绝原因：" prop="refuseReason">
          <el-input v-model="formData.refuseReason" type="textarea" :rows="4" placeholder="请输入拒绝原因" maxlength="200" show-word-limit></el-input>
        </el-form-item>

        <el-form-item label="最低直播价：" prop="minLivePrice">
          <el-input-number v-model="formData.minLivePrice" placeholder="请输入最低直播价" :controls="false" :min="1" :precision="0"></el-input-number>
        </el-form-item>
      </el-form>
    </div>

    <template v-slot:footer>
      <div class="dialog-footer">
        <el-button @click="onCancel">取消</el-button>
        <el-button type="primary" @click="onSubmit" :loading="submitting">提交</el-button>
      </div>
    </template>
  </q-dialog>
</template>

<script>
export default {
  name: 'RejectDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    rowData: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
  },
  data() {
    return {
      submitting: false,
      formData: {
        refuseReason: '',
        minLivePrice: undefined,
      },
      rules: {
        refuseReason: [{ required: true, message: '请输入拒绝原因', trigger: 'blur' }],
        minLivePrice: [{ required: true, message: '请输入最低直播价', trigger: 'blur' }],
      },
    };
  },
  methods: {
    onCancel() {
      this.isVisible = false;
    },

    onSubmit() {
      this.$refs.rejectForm.validate(valid => {
        if (!valid) return;
        this.submitting = true;
        let data = {
          id: this.rowData.id,
          batchCode: this.rowData.batchCode,
          status: -1,
          ...this.formData
        };
        this.$q.goods.goodsLiveSpecialPriceApprove({ data: data }).then(res => {
          this.$message.success('提交成功');
          this.$emit('success');
          this.isVisible = false;
        }).finally(() => {
          this.submitting = false;
        });
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
>>> .el-date-editor.el-input__inner, >>> .el-select, >>> .el-input, >>> .el-input-number {
  width: 100% !important;
}

.dialog-footer {
  text-align: center;
  padding-top: 10px;
}
</style>
